'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AdminOnlyWrapper = require('ui-addon-upgrades/_core/common/components/AdminOnlyWrapper');

var _AdminOnlyWrapper2 = _interopRequireDefault(_AdminOnlyWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AdminOnlyWrapper2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/decorators/UIAdminOnlyWrapper.js
// module id = 618
// module chunks = 3 4